import { PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { Category } from "../generated-interfaces/graphql";
import { MENU_EDITOR_ROUTES } from "../pages/menu-editor/menu-editor-routes";
import { duplicateCategory, getMenu } from "../reducers/menuReducer";
import { selectedRestaurantCodeSelector } from "../selectors/restaurant";
import { IDuplicatePayload } from "../types/menu";
import logger from "../utils/logger";
import { getSdk } from "../utils/network";
import { PerfTimer } from "../utils/timer";
import { getAuthInfo } from "./utilsSaga";

function* duplicateCategorySaga(action: PayloadAction<IDuplicatePayload>) {
    const timer = new PerfTimer();
    logger.debug("Duplicating category");
    const { token, isAuth0 } = yield call(getAuthInfo);
    const sdk = getSdk(token, isAuth0);
    const { id: sourceCategoryId, successCallback, errorCallback } =
        action?.payload || {};
    try {
        const restaurantCode: string = yield select(
            selectedRestaurantCodeSelector
        );

        const dupCategoryResponse: {
            duplicateCategory: Category;
        } = yield sdk.duplicateCategory({
            restaurantCode,
            sourceCategoryId,
            version: 0,
        });

        yield put(
            push(
                MENU_EDITOR_ROUTES(restaurantCode)[
                    "duplicateCategory"
                ].path.replace(":id", dupCategoryResponse.duplicateCategory.id)
            )
        );

        yield put(getMenu());
        successCallback?.();

        logger.info("Duplicate category successful", {
            duration: timer.stop(),
        });
    } catch (error) {
        errorCallback?.();
        logger.error("Duplicate category failed", {
            error,
            duration: timer.stop(),
        });
    }
}

export default function* categorySaga() {
    yield takeEvery(duplicateCategory.toString(), duplicateCategorySaga);
}
